import { render, staticRenderFns } from "./EmptyFunctionIcon.vue?vue&type=template&id=668cfda9"
import script from "./EmptyFunctionIcon.vue?vue&type=script&lang=js"
export * from "./EmptyFunctionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports